import React from 'react';
import Button from 'components/ReusableUI/Button';
import { Image } from 'react-datocms';
import LargeButton from '../Views/Buttons';
import { BlackHeading, LargeHeading, SectionHeading } from '@/components/Views/Heading';
import { useDispatchUi } from 'context/ui';
import StructuredText from "@/components/ReusableUI/StructuredText";
import IpadMedley from "@/components/IpadMedley/IpadMedley";
import { ComponentProps } from "@/components/component";
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

interface Props {
    id?: string;
    component?: ComponentProps;
    className?: string;
    background?: string;
    pricingURL?: string;
    ctaSignupButtonClass?: string;
    ctaSignupButton?: string;
    textClass?: string;
    videoButtonText?: string;
    pricingCTA?: string;
    pricingClassName?: string;
}


const ContentSection = ({ id, component, background, className, pricingURL, pricingCTA, pricingClassName, ctaSignupButtonClass, ctaSignupButton, textClass, videoButtonText }: Props) => {
    const { featuredImage, heading, extraData, videoLink, content, ctaVideoButton } = component;
    const { featuredImageIpadMedley = false, backgroundBlobs = false } = extraData || {};
    const dispatch: any = useDispatchUi();

    return (
        <section id={id} className={`default-px default-py w-full font-Inter ${className}`} style={{ background }}>
            <SectionHeading
                text={heading}
                className='!mb-10 lg:whitespace-pre-line text-MuzologyDarkPurple'
            />

            <div className='my-0 mx-auto flex flex-col lg:flex-row gap-6 items-center justify-center default-max-w'>

                <div className='w-full h-full relative'>
                    {backgroundBlobs
                        && <div className='z-10 bg-no-repeat bg-center bg-contain absolute left-0 right-0 top-[-16%] bottom-[-40%] bg-[url("/backgrounds/background-blobs.png")] ' />}
                    <div className='z-20 relative w-full my-0 mx-auto flex items-center justify-center max-w-[640px]'>
                        {featuredImage && <Image data={{ ...featuredImage.responsiveImage, bgColor: '#ffffff00' }} />}
                        {featuredImageIpadMedley && <IpadMedley className='mr-8' />}
                    </div>
                </div>

                <div className='z-30 lg:pb-12 md:pb-0 w-full flex flex-col'>

                    <div className='pr-0 lg:pr-8'>
                        <StructuredText data={content} className={`text-left ${textClass ?? 'text-black'}`} />
                    </div>
                    <div className='w-full flex justify-center lg:justify-start mt-2 md:mt-7'>

                        <div className='button-group'>
                            <LargeButton
                                id={id + '-start-free-trial'}
                                href={MUZOLOGY_SIGNUP_URL}
                                className={`${ctaSignupButtonClass ?? 'dark-orange-button'} w-[230px] uppercase`}
                                text={pricingCTA ?? 'Start Free Trial'}
                            />

                            <LargeButton
                                id={id + '-how-it-works'}
                                className='dark-button w-[230px] uppercase'
                                text={videoButtonText ?? 'How it Works'}
                                onClick={() => dispatch({ type: 'PLAY_VIDEO', payload: videoLink })}
                                rightDelta={true}
                            />
                        </div>

                        {ctaVideoButton && (
                            <div className='ml-4'>
                                <Button id={id + '-watch-video'} className='dark-button'>
                                    <div className='flex items-center justify-start py-0.5'>
                                        <div className='text-white px-4 text-base  font-medium'>Watch Video</div>
                                        <div className='mt-1'>
                                            <svg xmlns='http://www.w3.org/2000/svg' width='15' height='20' fill='none'>
                                                <path
                                                    fill='#FFFCFC'
                                                    fillRule='evenodd'
                                                    d='M0 2v16a1 1 0 0 0 1.524.852l13-8a1 1 0 0 0 0-1.704l-13-8A1 1 0 0 0 0 2Zm2 1.79L12.091 10 2 16.21V3.79Z'
                                                    clipRule='evenodd'
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </Button>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ContentSection;
